
import { JsonTreeViewerComponent } from '@product/shared/layout/json-tree-viewer/json-tree-viewer.component';
import { LoginComponent } from './authentication/Login/Login.component';
import { CategoryComponent } from './cataloge/category/category/category.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CreateComponent } from './shared/base/create/create.component';
import { EditComponent } from './shared/base/edit/edit.component';
import { IsAuthorized } from './guards/IsAuthorized';
import { HomeComponent } from './home/home.component';
import { ResetPassComponent } from './authentication/reset-pass/reset-pass.component';
import { RegisterUserComponent } from './authentication/register-user/register-user.component';
import { UserProfileComponent } from './authentication/user-profile/user-profile.component';
import { BulkEditComponent } from './bulk-edit/bulk-edit.component';

const routes: Routes = [
  
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    component: HomeComponent,
  },
  
  {
    path: 'auth',
    children: [
      {
        path: 'login',
        component: LoginComponent,
      },
      {
        path: 'reset-password',
        component: ResetPassComponent,
      },
      {
        path: 'register',
        component: RegisterUserComponent,
      },
      
    ],
  },

  {
    path: 'profile',
    component: UserProfileComponent,
  },
  {
    path: 'settings',
    loadChildren: () =>
      import('./settings/settings.module').then((x) => x.SettingsModule),
  },
  {
    path: 'cataloge',
    children: [
      {
        path: ':model',
        component: CategoryComponent,
        children: [
          {
            path: 'create',
            component: CreateComponent,
          },
          {
            path: 'edit/:id',
            component: EditComponent,
          },

         
        ],
      },
     
    ],
  },
  {
    path: 'license',
    loadChildren: () =>
      import('./license/license.module').then((x) => x.LicenseModule),
  },
  {
    path: 'product-catalog',
    loadChildren: () =>
      import('./product-catalog/catalog-product.module').then((x) => x.CatalogProductModule),
  },
  {
    path: 'product',
    loadChildren: () =>
      import('./product/product.module').then((x) => x.ProductModule),
  },
  {
    path: 'completion',
    loadChildren: () =>
      import('./completion/completions.module').then(
        (x) => x.CompletionsModule
      ),
  },
  {
    path: 'data-export',
    canActivate: [IsAuthorized],
    loadChildren: () =>
      import('./data-export/data-export.module').then(
        (x) => x.DataExportModule
      ),
  },
  {
    path: 'data-import',
    canActivate: [IsAuthorized],
    loadChildren: () =>
      import('./data-import/data-import.module').then(
        (x) => x.DataImportModule
      ),
  },
  {
    path: 'management',
    data: {
      role: 'Admin',
    },
    canActivate: [IsAuthorized],
    loadChildren: () =>
      import('./management/management.module').then((x) => x.ManagementModule),
  },
  {
    path: 'integration',
    loadChildren: () =>
      import('./integration/integration.module').then(
        (x) => x.IntegrationModule
      ),
  },
  {
    path: 'relationships',
    loadChildren: () =>
      import('./Relationships/Relationships.module').then(
        (x) => x.RelationshipsModule
      ),
  },
  {
    path: 'bulk-edit/:id',
    canActivate: [IsAuthorized],
    component: BulkEditComponent,
  },
  {
    path: 'json-tree-viewer',
    canActivate: [IsAuthorized],
    component: JsonTreeViewerComponent,
  },
  {
    path: 'error',
    loadChildren: () =>
      import('./error-pages/error-pages.module').then(
        (m) => m.ErrorPagesModule
      ),
  },
  {
    path: '**', redirectTo: 'error/404'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
